import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomImageUpload from "../../component/CustomImageUpload";

const EditEndpoint = ApiEndpoints.clientLogo.Edit;
const UpdateEndPoint = ApiEndpoints.clientLogo.Update;

export default function EditClientLogo() {
  const { clientlogo_id } = useParams();
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    alt_logo: "",
    logo: null,
  });

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", `${EditEndpoint}${clientlogo_id}`);
        const result = response.logo;
        setFormData({ logo: null, alt_logo: result.alt_logo || "" });
        setPreviewImage(result.logo ? `${BaseUrl}${result.logo}` : "");
      } catch (error) {
        console.error("Error fetching client logo data:", error);
      }
    };
    dataFetch();
  }, [clientlogo_id]);


  const handleChange = useCallback((event) => {
    const { name, value, type, files } = event.target;
    if (name === "logo" && type === "file") {
      const file = files[0];
      if (file) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewImage(objectUrl);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key !== "logo") {
          payload.append(key, formData[key]);
        }
      });
      if (formData.logo) {
        payload.append("logo", formData.logo);
      }
      payload.append("logo_id", clientlogo_id);

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", UpdateEndPoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(response.message)
        navigate("/client-logos");
      } catch (error) {
        console.error("Error updating client logo:", error);
      }
    },
    [clientlogo_id, formData, navigate]
  );

  const pagename = {
    name: 'Logo Management',
    user: 'Admin',
    innerpage: 'Logo Management / Logo / Edit Logo'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="logoEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Image (160 x  72 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="logo"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previewImage}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Alt Image<small>*</small></label>
                  </div>
                  <input value={formData?.alt_logo} type="text" name="alt_logo" onChange={handleChange} className="form-control" required />
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="logoEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}

